<template>
  <div class="wrap-detail fontSpecial custom-bg-wrap2">
    <div class="top-bg1">
      <div class="title">
        <p>您的体质为：{{detail.bodyName}}</p>
      </div>
    </div>
    <div class="center-bg1">
      <!-- Echart -->
      <div class="box">
        <div id="myChart" :style="{width: '5.57rem', height: '4.07rem'}"></div>
      </div>

      <!-- 文字区域 -->
      <div class="main">
        <div class="main-item" v-html="detailContent"></div>
      </div>

      <!-- 底部 -->
      <div class="footer">
        <div class="item" v-for="(item,index) in detailList" :key="index">
          <div @click="selectUp(item)" class="top">
            <img src="../../assets/image/detail/logo.png" alt />
            <span>{{item.descItem}}</span>
            <i :class="item.expand ? 'i-top' : 'i-up'"></i>
          </div>
          <div v-show="item.expand" class="cont">
            <div class="inner" v-html="item.descContent"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bg">
      <button @click="shade = true" class="addForm-one"></button>
    </div>
    <!-- <div class="header-box">
      <div class="detail-title">
        <p>您的体质为：{{detail.bodyName}}</p>
      </div>
    </div>-->
  </div>
</template>

<script>
import { getApi, postApi } from "../../api/index.js";
export default {
  data() {
    return {
      resultId: "",
      detail: {},
      bodyTypeName: [],
      bodyTypeScore: [],
      myChart: null,
      detailContent: "",
      detailList: []
    };
  },
  created() {
    this.resultId = this.$route.query.resultId;
    this.getResult();
  },
  mounted() {
    this.myChart = this.$echarts.init(document.getElementById("myChart"));
  },
  methods: {
    selectUp(item) {
      if (item.expand) {
        item.expand = false;
      } else {
        this.$set(item, "expand", true);
      }
    },
    getResult() {
      getApi({ url: "/chinese/testResultDetail/" + this.resultId, query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              this.detail = res.data;
              this.bodyTypeName = this.detail.bodyTypeName;
              this.bodyTypeScore = this.detail.bodyTypeScore;
              if (this.detail.desc && this.detail.desc.length > 0) {
                this.detailList = [];
                this.detailContent = this.detail.desc[0].descContent;
                this.detail.desc.forEach((element, index) => {
                  if (index > 0) {
                    this.detailList.push(element);
                  }
                });
              }
              this.drawLine();
            }
          }
        })
        .catch(res => {});
    },
    drawLine() {
      // 绘制图表
      this.myChart.setOption({
        title: {},
        tooltip: {},
        grid: {
          y2: 50,
          top: "10%"
        },
        xAxis: {
          data: this.bodyTypeName,
          axisLabel: {
            interval: 0,
            rotate: 45
          }
        },
        yAxis: {},
        series: [
          {
            name: "分",
            type: "bar",
            data: this.bodyTypeScore,
            barWidth: 17,
            barMarginRight: 100
          }
        ]
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../common/css/style.less";
.wrap-detail {
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  .header-box {
    height: 100%;
    padding-bottom: 0.98rem;
    overflow: hidden;
    text-align: center;
  }
  .detail-title {
    // width: 5.08rem;
    height: 0.44rem;
    margin-top: 1.79rem;
    text-align: center;
    font-size: 0.48rem;
    color: rgb(51, 51, 51);
    font-family: "thin";
  }
}
.box {
  width: 100%;
  text-align: center;
  #myChart {
    // width: 5.57rem;
    // height: 3.07rem;
    display: inline-block;
  }
}
.main {
  width: 100%;
  text-align: center;
}
.main-item {
  display: inline-block;
  width: 5.45rem;
  // background-color: aquamarine;
  padding-bottom: 0.8rem;
  text-align: left;
  font-size: 0.3rem;
  font-family: "thin";
  color: rgb(51, 51, 51);
}
.footer {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.96rem 0 0.94rem;
}
.item {
  width: 100%;
  border: 0.02rem solid rgb(126, 73, 16);
  box-sizing: border-box;
  margin-bottom: 0.09rem;
  .top {
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: left;
    box-sizing: border-box;

    padding-left: 0.23rem;
    span {
      font-family: "thin";
      font-size: 0.3rem;
      color: rgb(51, 51, 51);
    }
    img {
      width: 0.5rem;
      height: 0.48rem;
      margin-right: 0.22rem;
    }
    i {
      //  display: inline-block;
      float: right;
      // display: inline;
      margin: 0.38rem 0.19rem 0 0;
      box-sizing: border-box;
      width: 0.2rem;
      height: 0.16rem;
      background-size: 100%;
      background-repeat: no-repeat;
      // margin-left: 2.53rem;
      // background-image: url(..)
      // background-image: url(../../assets/image/detail/button.png);
    }
    .i-up {
      background-image: url(../../assets/image/detail/button.png);
    }
    .i-top {
      background-image: url(../../assets/image/detail/top.png);
    }
  }
}
.cont {
  width: 100%;
  .inner {
    // width: 3.9rem;
    // height: 1.05rem;
    font-size: 0.26rem;
    font-family: "thin";
    text-align: left;
    box-sizing: border-box;
    padding-left: 0.23rem;
    line-height: 0.4rem;
    margin-bottom: 0.31rem;
  }
}
</style>